/**
 * RecordMetric CrossFrame Listener
 *
 * No-op listener to support migration of legacy tools that broadcast
 * RecordMetric messages via CrossFrameUtils.
 * See: https://code.amazon.com/packages/IhmAssociateToolsJSLib/blobs/a399e476431540152a5765adcf6d2992dbe81b5b/--/src/metrics/Metrics.ts#L154
 */

export async function recordMetricListener (_message: any): Promise<void> {
    // Intentional no-op for legacy compatibility
}
